import { render, staticRenderFns } from "./LabelEnumValue.vue?vue&type=template&id=0cad2e2a&scoped=true&"
import script from "./LabelEnumValue.vue?vue&type=script&lang=ts&"
export * from "./LabelEnumValue.vue?vue&type=script&lang=ts&"
import style0 from "./LabelEnumValue.vue?vue&type=style&index=0&id=0cad2e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cad2e2a",
  null
  
)

export default component.exports